import { useEffect, useState, FC } from 'react';
import Draggable, { DraggableBounds } from 'react-draggable';
import { useWindowSize } from 'app/utils/hooks';
import { Box, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { useAppSelector } from 'app/store';
import { getPlayerHeight } from 'app/store/AudioPlayer/selectors';

interface ChakraDraggablePopoverProps {
  anchorEl: HTMLButtonElement | null;
  width: number;
  height: number;
  children?: React.ReactNode;
}

export const ChakraDraggablePopover: FC<ChakraDraggablePopoverProps> = ({
  children,
  anchorEl,
  width,
  height,
}) => {
  const windowSize = useWindowSize();
  const [bounds, setBounds] = useState<DraggableBounds>({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  });
  const popperTopOffset = 56;
  const updateBounds = (anchorEl: HTMLButtonElement | null) => {
    if (anchorEl) {
      const bounds = anchorEl?.getBoundingClientRect();
      const bottom =
        window.innerHeight - bounds.top - bounds.height + popperTopOffset - 1;
      const right = window.innerWidth - bounds.left;
      const top = -(window.innerHeight - height) + bottom;
      const left = -(window.innerWidth - width) + right;
      setBounds({
        bottom,
        right,
        top,
        left,
      });
    }
  };
  useEffect(() => {
    updateBounds(anchorEl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorEl, width, height, windowSize]);

  const playerHeight = useAppSelector(getPlayerHeight);

  return (
    <Popover
      isOpen={Boolean(anchorEl)}
      placement="top-end"
      modifiers={[
        {
          name: 'offset',
          enabled: true,
          options: {
            offset: [0, popperTopOffset + 32 + playerHeight],
          },
        },
      ]}
    >
      <PopoverTrigger>
        <Box />
      </PopoverTrigger>
      <PopoverContent
        height={height}
        width={width}
        boxShadow="none"
        border="none"
        _focus={{ boxShadow: 'none' }}
        bgColor="transparent"
      >
        {Boolean(anchorEl) && <Draggable bounds={bounds}>{children}</Draggable>}
      </PopoverContent>
    </Popover>
  );
};
